import React, { useEffect, useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useParams } from "react-router-dom";

import { fetchFromAPI } from "../utils/fetchFromAPI";
import { Videos, ShortVideo, Sidebar ,Side, VideoDetail,Loader} from "./";
import { Link } from "react-router-dom";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';


function Shorts() {
    const [videos, setVideos] = useState(null);
    const [currentVideo, setCurrentVideo] = useState(null);
    const { selectedCategory } = useParams();
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        fetchFromAPI(`search?part=snippet&q=Shorts`)
          .then((data) => {
            setVideos(data.items)
            setCurrentVideo([data.items[0]])
            console.log(data.items[0])
          
          })


          
        
    }, []);
    const goToPrevious = () => {
      
      const isFirstSlide = currentIndex === 0;
      const newIndex = isFirstSlide ? videos.length - 1 : currentIndex - 1;
      setCurrentIndex(newIndex);
      setCurrentVideo([videos[newIndex]])
    };
    const goToNext = () => {
      console.log("next")
      console.log(videos)
      const isLastSlide = currentIndex === videos.length - 1;
      const newIndex = isLastSlide ? 0 : currentIndex + 1;
      console.log(currentVideo)
      setCurrentIndex(newIndex);
      setCurrentVideo([videos[newIndex]])
    };
    


    


    return (
    

        <Stack width="100%" direction="row" sx={{gap:"20px", alignItems:"center",justifyContent:"center", overflowY: "auto", height: "90vh" }}>
          {/* <Typography variant="h4" fontWeight="bold" mb={2} sx={{ color: "white" }}>
            Shorts <span style={{ color: "#FC1503" }}>videos</span>
          </Typography> */}

          
        
          <ShortVideo style={{borderRadius:"10px"}} currentVideo={currentVideo} />

          <Stack direction="column" gap="70px">
            <Box onClick={goToPrevious} marginTop="5px" sx={{color:"white", height:"2rem",width:"2rem",borderRadius:"50%", cursor:"pointer","&:hover": { backgroundColor:"#A0A0A0" } }}>
              <ArrowUpwardIcon size="lg" style={{height:"2rem",width:"2rem",cursor:"pointer","&:hover": { backgroundColor:"#A0A0A0" } }}/>
            </Box>

            <Box onClick={goToNext} marginBottom="5px" sx={{color:"white", height:"2rem",width:"2rem", borderRadius:"50%", cursor:"pointer","&:hover": { backgroundColor:"#A0A0A0" } }}>
              <ArrowDownwardIcon size="lg" style={{height:"2rem",width:"2rem",cursor:"pointer","&:hover": { backgroundColor:"#A0A0A0" } }}/>
            </Box>
          </Stack>
        </Stack>
      // </Stack>
    );
}

export default Shorts